import type { ProductCatalogVariant } from 'modules/it_management/lib/productCatalogGraphql'

export type DistributorProductVariant = ProductCatalogVariant

export type DistributorOffer = NonNullable<DistributorProductVariant['offers']>[number]

export type OfferType = 'renting' | 'credit' | 'onetime'

export type DeviceCatalogView = 'all' | 'saved' | 'offers' | 'zero-touch' | 'category'

export type AttributeFilters = Record<string, string[]>

export type FilterSection = {
  id: string
  label: string
  options: { value: string; label: string }[]
  selectedValues: string[]
  onChange: (values: string[]) => void
}

export type ProductGroup = {
  id: string
  title: string
  description?: string
  items: DistributorProductVariant[]
}

/**
 * Maps category IDs to backend product type_name values.
 * Backend canonical values come from ItManagement::Constants::AssetTypes::TYPE_NAMES.
 */
export const CATEGORY_TYPE_MAP: Record<string, string[]> = {
  accessories: ['mouse', 'keyboard', 'headset'],
  audio_video: ['headset', 'screen'],
  computers: ['laptop', 'desktop'],
  mobile_phones: ['phone'],
  monitors: ['screen'],
  networking_it: ['other'],
  tablets: ['tablet'],
  wearables: ['other'],
}

export const SAVED_IDS_STORAGE_KEY = 'device_catalog_saved_ids'

// ---- Cart types ----

export type CartItemAddon = {
  id: string
  label: string
  pricePerMonth: number
}

export type CartItem = {
  variantId: string
  /** Product id for marketplace cell API (variant.product?.id or variantId fallback) */
  productId?: string
  name: string
  price: number
  image: string
  quantity: number
  addons: CartItemAddon[]
  offerId: string
  /** For display: 'onetime' | 'renting' | 'credit' */
  offerType: OfferType
  /** Period in months (null for onetime) */
  offerPeriod: number | null
}

export const CART_STORAGE_KEY = 'device_catalog_cart'
